import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  List,
  ListItem,
  Button,
  Icon,
  makeStyles,
} from "@material-ui/core";
import Badge from '@mui/material/Badge';
import services from "../Services";
import { CaretDownOutlined, DollarCircleFilled, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

import { Link, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { getRoleID, haveAccessByRole, NoTokenLogout } from "../helpers";
import { ArrowDownward, CloseRounded, LocalGasStation } from "@material-ui/icons";
import roleManager from "./roles";
import { useSelector } from "react-redux";
import { utility } from "../helpers/loader";
import { setSidebarCollapse } from "../redux/features/utils.slice";
import { getRolesPayroll } from "../Services/hr";
import { getAllPayroll } from "../Services/employee";
import { message } from "antd";

const { hr } = services;


const LeftControl = () => {

  let { pathname } = useLocation();
  const history = useHistory()
  const [badgeNotification, setBadgeNotification] = useState();
  const [badgeNewHireQue, setBadgeNewHireQue] = useState();

  const userProfile = JSON.parse(localStorage.getItem("user_profile"));
  const HR_CATEGORY_ID = 1;
  const IT_CATEGORY_ID = 2;
  const [hasFetchedData, setHasFetchedData] = useState(false);
  const [RoleData, setRoleData] = useState(false);
  const [loading, setLoading] = useState(true); // Track loading state for user profile
  const [PayrollRoleData, setPayrollRoleData] = useState(false); // Track permission state

  // Function to fetch data
  const checkEmployee = localStorage?.isEmployee == false; // Convert to boolean
  const fetchData = async () => {
    if (!checkEmployee) { // if checkEmployee is false, the user is an employee
      return; // Exit the function early if the user is an employee
    }

    try {
      const data = await getRolesPayroll();
      setRoleData(data); // Pass the fetched data back to the parent
    } catch (error) {
    }
  };

  const getPayrolls = async () => {
    try {

      const response = await getAllPayroll();
      const data = response?.data;
      return data.map(employee => employee.UserId);
    } catch (error) {
      return []; // Return empty array in case of error to prevent breaking further logic
    }
  };

  const checkUserPermission = async (userProfileId) => {
    const currentPath = window.location.pathname;

    setLoading(true);
    if (currentPath === '/application') {
      return;
    }

    const employeeIds = await getPayrolls();
    if (employeeIds.includes(userProfileId)) {
      setPayrollRoleData(true);
    } else {
      setPayrollRoleData(false);
    }
    if (currentPath === '/pending-payroll-tickets') {
      if (employeeIds.includes(userProfileId)) {
        history.push('/pending-payroll-tickets');

      } else {
        message.error("Access Denied")
        history.push('/dashboard');
      }
    } else {
      console.log('User is allowed to navigate to other routes');
    }
    setLoading(false);

  };


  useEffect(() => {
    if (!userProfile || !userProfile.id) {
      return;
    }
    const userProfileId = userProfile.id;
    checkUserPermission(userProfileId);
  }, []);

  useEffect(() => {
    if (!hasFetchedData) {

      fetchData(); // Fetch data only once
      setHasFetchedData(true);
    }
  }, [hasFetchedData]);
  let { collapse } = useSelector(state => state.utils)

  const getTicketCount = async () => {
    let categoryId = haveAccessByRole(18) ? 3 : (haveAccessByRole(2) || haveAccessByRole(3)) ? IT_CATEGORY_ID : HR_CATEGORY_ID
    let result = await hr?.ticketCount({ id: categoryId });
    if (result && result.httpStatus == 200) {
      setBadgeNotification(result?.data?.count)
    }
  }

  const getNewHireQueCount = async () => {
    let result = await hr?.NewHirequeCount();
    if (result && result.httpStatus == 200) {
      setBadgeNewHireQue(result?.data?.count)
    }
  }

  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user_profile"));
    if (userProfile) {
      getTicketCount();
      getNewHireQueCount();
    }
  }, []);
  useEffect(() => {
  }, [PayrollRoleData]);

  return (
    <Grid xs={12} md={2} className={collapse ? "LeftContol-closed" : "LeftContol"} >
      <Grid className="BrandLogo" ></Grid>
      {!collapse && <MenuFoldOutlined onClick={() => utility?.dispatch(setSidebarCollapse(true))} style={{ cursor: "pointer", fontSize: "20px", color: "white", position: "absolute", top: "10px", right: "10px" }} />}
      <Grid className="TGSNav" >
        <List component="nav" aria-label="main mailbox folders" >
          <div id="nav-container" style={{ overflow: 'hidden' }}>
            <div onClick={() => NoTokenLogout(history)}>
              {roleManager("sidebar", "dashboard") && (
                <ListItem button className="DashIcon">
                  <Link
                    to="/dashboard"
                    className={`Liq-NavLinks ${pathname === "/dashboard" ? "NavSelected" : ""}`}
                  >
                    <Icon />
                    Dashboard
                  </Link>
                </ListItem>
              )}
            </div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "new_hire_queue") && (
              <ListItem button className="NewHireIcon">
                <Link
                  to="/new-hire-queue"
                  className={`Liq-NavLinks ${pathname === "/new-hire-queue" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  New Hire Queue
                </Link>
              </ListItem>
            )}</div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "new_hire_queue_it") && (
              <ListItem button className="NewHireIcon">
                <Link
                  to="/new-hire-queue-it"
                  className={`Liq-NavLinks ${pathname === "/new-hire-queue-it" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  New Hire Queue IT
                  <Badge badgeContent={badgeNewHireQue} color="success" style={{ marginLeft: '15px' }}>
                  </Badge>

                </Link>
              </ListItem>
            )}</div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "tickets_alerts") && (
              <ListItem button className="AlertIcon">
                <Link
                  to="/tickets-alerts"
                  className={`Liq-NavLinks ${pathname === "/tickets-alerts" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  Tickets/Alerts
                  <Badge badgeContent={badgeNotification} color="success" style={{ marginLeft: '15px' }}>
                  </Badge>
                </Link>
              </ListItem>
            )}</div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "create_ticket") && (
              <ListItem button className="CreatLinkIcon">
                <Link
                  to="/create-ticket"
                  className={`Liq-NavLinks ${pathname === "/create-ticket" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  Create a ticket
                </Link>
              </ListItem>
            )}</div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "safety") && (
              <ListItem button className="SafetyIcon">
                <Link
                  to="/safety-testing"
                  className={`Liq-NavLinks ${pathname === "/safety-testing" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  Safety Testing
                </Link>
              </ListItem>
            )}</div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "employees") && (
              <ListItem button className="EmployeeIcon">
                <Link
                  to="/employees"
                  className={`Liq-NavLinks ${pathname === "/employees" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  Employees
                </Link>
              </ListItem>
            )}</div>

            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "hardware") && (<ListItem button className="EmployeeIcon">
              <Link
                to="/hardware"
                className={`Liq-NavLinks ${pathname === "/hardware" ? "NavSelected" : ""}`}
              >
                <Icon />
                Hardware Management
              </Link>
            </ListItem>
            )}</div>

            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "payroll") && (<ListItem button className="payrollIcon">
              <Link
                to="/payroll-tickets"
                className={`Liq-NavLinks ${pathname === "/payroll-tickets" ? "NavSelected" : ""}`}
              >
                <Icon />
                Payroll Tickets/Alerts
              </Link>
            </ListItem>
            )}</div>
            {/* <div onClick={() => NoTokenLogout(history)}>{PayrollRoleData?.includes(userProfile?.id) &&(<ListItem button className="pendingPayrollIcon">
              <Link
                to="/pending-payroll-tickets"
                className={`Liq-NavLinks ${pathname === "/pending-payroll-tickets" ? "NavSelected" : ""}`}
              >
                <Icon />
                Pending Payroll Approval
              </Link>
            </ListItem>
            )}</div> */}
            <div onClick={() => NoTokenLogout(history)}>
              {PayrollRoleData && (
                <ListItem button className="pendingPayrollIcon">
                  <Link
                    to="/pending-payroll-tickets"
                    className={`Liq-NavLinks ${pathname === "/pending-payroll-tickets" ? "NavSelected" : ""}`}
                  >
                    <Icon />
                    Pending Payroll Approval
                  </Link>
                </ListItem>
              )}
            </div>
            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "broadcast_message") && (
              <ListItem button className="MessageIcon ">
                <Link
                  to="/broadcast-messages"
                  className={`Liq-NavLinks ${pathname === "/broadcast-messages" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  Broadcast Message
                </Link>
              </ListItem>
            )}</div>

            <div
              onClick={() => NoTokenLogout(history)}>
              {roleManager("sidebar", "fuel_management") && (
                <ListItem button>
                  <Link
                    to="/fuel-management"
                    className={`Liq-NavLinks ${pathname === "/fuel-management" ? "NavSelected" : ""}`}
                  >
                    <LocalGasStation style={{
                      fontSize: "25px",
                      marginRight: "15px",
                      color: pathname === "/fuel-management" ? "#043b8b" : "white"
                    }} />
                    Fuel Management
                  </Link>
                </ListItem>
              )}
            </div>

            <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "equipmentLookup") && (
              <ListItem button className="equipLookup">
                <Link
                  to="/equipmentlookup"
                  className={`Liq-NavLinks ${pathname === "/equipmentlookup" ? "NavSelected" : ""}`}
                >
                  <Icon />
                  Equipment Lookup
                </Link>
              </ListItem>
            )}</div>



            {/* Locomotive--------------------------------------------------------> */}
            <div onClick={() => NoTokenLogout(history)}>
              {roleManager("sidebar", "locomotiveMain") &&
                (
                  <ListItem
                    style={{ display: "flex", flexDirection: 'column' }}
                    className={
                      // (pathname === "/equipmentlookup") |
                      (pathname === "/locomotivelookup") |
                        (pathname === "/Locomotivelisting") |
                        (pathname === "/locomotivetickets") |
                        (pathname === "/Locomotiveworkorders") |
                        (pathname === "/LocomotiveEdit") |
                        (pathname === "/LocomotiveTicketEdit") |
                        (pathname === "/Locomotive-work-order-edit")





                        // (pathname === "/equipmentlookupedit")
                        ? "DeptSelected Locomotive Liq-NavLinks"
                        : "Locomotive Liq-NavLinks"
                    }
                  >
                    <Link
                      to={roleManager("sidebar", "locomotive") ? "/Locomotivelisting" : (roleManager("sidebar", "locomotiveTicket") ? "/locomotivetickets" : "/Locomotiveworkorders")}
                      className={
                        (pathname === "/Locomotivelisting") |
                          (pathname === "/locomotivelookup") |
                          (pathname === "/locomotivetickets") |
                          (pathname === "/Locomotiveworkorders")
                          // (pathname === "/information-technology")
                          ? "NavSelected Liq-NavLinks"
                          : "Liq-NavLinks"
                      }
                    >
                      <Icon />
                      Locomotive
                    </Link>
                    <List component="nav" className="DeptFolder">
                      {roleManager("sidebar", "locomotive") &&

                        <ListItem button>
                          <Link
                            to="/Locomotivelisting"
                            className={
                              pathname === "/Locomotivelisting" ? "NavSubSelected" : ""
                            }
                          >
                            Locomotive Lookup
                          </Link>
                        </ListItem>
                      }


                      {roleManager("sidebar", "locomotiveTicket") &&
                        <ListItem button>
                          <Link
                            to="/locomotivetickets"
                            className={
                              pathname === "/locomotivetickets" ? "NavSubSelected" : ""
                            }
                          >
                            Tickets
                          </Link>
                        </ListItem>
                      }
                      {roleManager("sidebar", "locomotiveWorkOrder") &&
                        <ListItem button>
                          <Link
                            to="/Locomotiveworkorders"
                            className={
                              pathname === "/Locomotiveworkorders" ? "NavSubSelected" : ""
                            }
                          >
                            Work Orders
                          </Link>
                        </ListItem>
                      }

                    </List>
                  </ListItem>
                )}</div>
            {roleManager("sidebar", "systemAdmin") &&

              <div onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "equipmentLookup") && (

                <ListItem button className="equipLookup">
                  <Link
                    to="/systemAdminPage"
                    className={`Liq-NavLinks ${pathname === "/newPage" ? "NavSelected" : ""}`}
                  >
                    <Icon />
                    System Admin
                  </Link>
                </ListItem>
              )}</div>
            }
            {/* -------------------> Department <----------------  */}

            <div style={{ marginBottom: "20px" }} onClick={() => NoTokenLogout(history)}>{roleManager("sidebar", "deparment") && (

              <ListItem
                className={
                  (pathname === "/department") |
                    (pathname === "/human-resources") |
                    (pathname === "/operations") |
                    (pathname === "/safety") |
                    (pathname === "/information-technology")
                    ? "DeptSelected DepartmentIcon"
                    : "DepartmentIcon"
                }
              >
                <Link
                  to="/human-resources"
                  className={
                    (pathname === "/department") |
                      (pathname === "/human-resources") |
                      (pathname === "/operations") |
                      (pathname === "/safety") |
                      (pathname === "/information-technology")
                      ? "NavSelected Liq-NavLinks"
                      : "Liq-NavLinks"
                  }
                >
                  <Icon />
                  Department
                </Link>
                <List component="nav" className="DeptFolder">
                  <ListItem button>
                    <Link
                      to="/human-resources"
                      className={
                        pathname === "/human-resources"
                          ? "NavSubSelected"
                          : ""
                      }
                    >
                      Human Resources
                    </Link>
                  </ListItem>
                  <ListItem button>
                    <Link
                      to="/operations"
                      className={
                        pathname === "/operations" ? "NavSubSelected" : ""
                      }
                    >
                      Operations
                    </Link>
                  </ListItem>
                  <ListItem button>
                    <Link
                      to="/safety"
                      className={
                        pathname === "/safety" ? "NavSubSelected" : ""
                      }
                    >
                      Safety
                    </Link>
                  </ListItem>
                  <ListItem button>
                    <Link
                      to="/information-technology"
                      className={
                        pathname === "/information-technology"
                          ? "NavSubSelected"
                          : ""
                      }
                    >
                      Information Technology
                    </Link>
                  </ListItem>
                </List>
              </ListItem>
            )}</div>


          </div>
        </List>
      </Grid>
    </Grid>
  );
};
export default LeftControl;